import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';

import { PrismicProvider } from '@prismicio/react';

import App from './App';
import { client } from './prismic';
import store from './store';

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container); // createRoot(container!) if you use TypeScript
  root.render(
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <Provider store={store}>
        <PrismicProvider client={client}>
          <App />
        </PrismicProvider>
      </Provider>
    </BrowserRouter>
  );
}
